import"react";import{isNavigator as t}from"./misc/util.js";var r=t?navigator:void 0;r&&r.getBattery;
//# sourceMappingURL=useBattery.js.map
